// extracted by mini-css-extract-plugin
export default {"message":"ErrorHandler_message__urdA3"};